// dashboard.regions.index.tsx
// Route : /dashboard/regions — liste des régions (rôles ayant regionDashboard).
// Rendu via l'Outlet du layout parent dashboard.regions.tsx (qui fournit AppLayout).

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";

import { useAuth } from "@/application/contexts/AuthContext";
import { usePermissions } from "@/application/hooks/usePermissions";
import { RegionsPage } from "@/presentation/pages/RegionsPage";

const dashboardRegionsSearchSchema = z.object({
  siteSize: z.string().min(1).optional(),
});

interface DashboardRegionsSearch {
  siteSize?: string;
}

export const Route = createFileRoute("/dashboard/regions/")({
  component: function DashboardRegionsIndexComponent() {
    const search = Route.useSearch();
    const { isLoading } = useAuth();
    const permissions = usePermissions();
    const navigate = useNavigate();
    const navigateWithFilter = Route.useNavigate();

    useEffect(() => {
      if (!isLoading && !permissions.duerp.canViewRegions()) {
        void navigate({ to: "/" });
      }
    }, [isLoading, permissions, navigate]);

    return (
      <RegionsPage
        siteSizeFilter={search.siteSize}
        onSiteSizeFilterChange={(siteSize) =>
          void navigateWithFilter({
            search: { siteSize: siteSize || undefined },
            replace: true,
          })
        }
      />
    );
  },
  validateSearch: (search: Record<string, unknown>): DashboardRegionsSearch => {
    const parsed = dashboardRegionsSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
});
